// Enums
export enum OfferTimelineTypeEnum {
  Hour = 1,
  Day = 2,
  Week = 3
}

export enum OfferStatusEnum {
  Draft = 1,
  Approved = 2,
  Accepted = 3,
  Rejected = 4,
  Expired = 5,
  Cancelled = 6,
  Completed = 7,
  Archived = 8,
  Deleted = 9,
  Permanent_Deleted = 10,
  Admin_Suspended = 11,
  Admin_Rejected = 12,
  Admin_Deleted = 13,
  Admin_Permanent_Deleted = 14,
  Contracted = 15,
}

// Interfaces
export interface OfferFile {
  id: string;
  name?: string;
  size?: number;
  type?: string;
  path?: string;
  url?: string;
  content?: string;
}

export interface OfferTimelineType {
  id: OfferTimelineTypeEnum;
  name?: string;
}

export interface OfferStatus {
  id: OfferStatusEnum;
  name?: string;
}

export interface OfferUser {
  id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  rating?: number;
  totalJobs?: number;
  location?: string;
  address?: string;
}

export interface OfferJob {
  id: string;
  title?: string;
  description?: string;
  budget?: number;
  amount?: number;
  userId?: OfferUser;
}

export interface Offer {
  id?: string;
  timelineType: OfferTimelineType;
  status: OfferStatus;
  files: OfferFile[];
  isWarranty: boolean;
  isPartsIncluded: boolean;
  timeline: number;
  description: string;
  title: string;
  amount: number;
  user: OfferUser;
  job: OfferJob;
  createdAt?: string;
  updatedAt?: string;
  // Additional fields for purchased quotes
  type?: string;
  purchaseAmount?: number;
  purchaseCurrency?: string;
  purchaseDate?: string;
  // Additional fields for display
  projectTitle?: string;
  jobTitle?: string;
  coverLetter?: string;
  attachments?: OfferFile[];
  requirements?: string[];
  isEmergency?: boolean;
  emergencyTimeSlot?: string;
  emergencyDays?: number;
  client?: OfferUser;
  professional?: OfferUser;
}
